import React from "react";

import { Box, Flex, Link } from "src/components";

import { useBankingContent } from "src/banking/BankingContentContext";
import { Body } from "src/components/Content";
import { DynamicFields, DynamicForm, Form } from "src/components/Form";

const fields = () => ({ t }) => [
  {
    key: "username",
    label: t("login.username"),
    required: true,
  },
  {
    key: "password",
    label: t("login.password"),
    required: true,
    inputProps: {
      type: "password",
    },
  },
];

const renderLoginForm = ({
  handleSubmit,
  formKey,
  fields,
  renderButton,
  renderErrors,
  formSuccessMessage,
  renderFormSuccessMessage,
  errors,
  errorMessages,
  isValid,
  t,
  ...props
}) => {
  const pageData = useBankingContent();

  return (
    <Form onSubmit={handleSubmit} flexDirection={["column"]} pb={2}>
      {formSuccessMessage ? renderFormSuccessMessage(formSuccessMessage) : null}

      <Flex px={2} mr={[0]} flexDirection={["column"]}>
        {pageData.loginBoxContent ? (
          <Body padded={false} content={pageData.loginBoxContent.content} />
        ) : null}
        <DynamicFields
          fields={fields}
          formKey={formKey}
          errors={errors}
          {...props}
        />
      </Flex>

      {renderErrors({ errorMessages, errors })}

      <Box px={2}>
        <Flex mb={0}>
          {renderButton({
            isSubmitting: props.isSubmitting,
            isValid,
            t,
            formKey,
          })}
        </Flex>
        <Link
          to="/app/login/forgotPassword"
          color="green"
          mt={2}
          align="center"
          fontSize={2}
        >
          {t("login.forgotAuthentication")}
        </Link>
        <Link
          to="/app/login/enroll"
          color="green"
          mt={2}
          align="center"
          fontSize={2}
        >
          {t("login.enrollPrompt")}
        </Link>
      </Box>
    </Form>
  );
};

// This allows login info to be passed via an environment variable during
// development.
const initialValues = {
  username: process.env.USERNAME || "",
  password: process.env.PASSWORD || "",
};

const LoginEntryForm = props => (
  <DynamicForm
    formKey="login"
    fields={fields()}
    needsCaptcha={false}
    renderForm={renderLoginForm}
    initialValues={initialValues}
    {...props}
  />
);

export default LoginEntryForm;



// WEBPACK FOOTER //
// ./src/banking/authentication/Login/steps/Entry.js